import { module }from 'stereomodularjs';
export default class extends module {
    constructor(m) {
        super(m);
        this.cursor = document.querySelector('.js-cursor'),
        this.triggers = document.querySelectorAll('[data-cursor-trigger]'),
        this.speed = 0.15,
        this.pos = {
            mouseX: 0,
            mouseY: 0,
            cursorX: 0,
            cursorY: 0
        },
        this.events = {
            onmouseenter: {
                showcursor: 'cursorIn'
            },
            onmouseleave: {
                showcursor: 'cursorOut'
            }
        }
    }

    animate(){
        let distX = this.pos.mouseX - this.pos.cursorX;
        let distY = this.pos.mouseY - this.pos.cursorY;
        this.pos.cursorX += (distX * this.speed);
        this.pos.cursorY += (distY * this.speed);
        this.cursor.style.left = this.pos.cursorX + 'px';
        this.cursor.style.top = this.pos.cursorY + 'px';
        requestAnimationFrame(()=>{this.animate()});
    }

    init() {
        eventAdd(document, 'mousemove', (event) => {
            this.pos.mouseX = event.pageX;
            this.pos.mouseY = event.pageY;
        });
        //console.log(this.triggers);
        if (this.triggers.length){
            this.animate();
            this.triggers.forEach(trigger => {
                //console.log('event add');
                //console.log(trigger);
                eventAdd(trigger, 'mouseenter', (event) => {
                    this.cursorIn(trigger)
                });
                eventAdd(trigger, 'mouseleave', (event) => {
                    this.cursorOut(trigger)
                });
            });
        }
    }

    cursorIn(element){
        document.querySelector('html').classList.add('is-cursor-active');
        if (element.getAttribute('data-cursor-type')){
            this.cursor.querySelector('[data-cursor-type="' + element.getAttribute('data-cursor-type') +'"]').classList.add('is-active');
        }else{
            this.cursor.querySelector('[data-cursor-type="default"]').classList.add('is-active');
        }
        //console.log('cursor in');
    }

    cursorOut(element){
        document.querySelector('html').classList.remove('is-cursor-active')
        classRemove(document.querySelectorAll('.c-cursor.is-active'), 'is-active');
    }

    destroy(){
        eventRemove(document, 'mousemove');
        this.triggers.forEach(trigger => {
            eventRemove(trigger, 'onmouseenter');
            eventRemove(trigger, 'onmouseleave');
        });
        //Remove class
        classRemove(document.querySelectorAll('.c-cursor.is-active'), 'is-active');
        classRemove(document.querySelector('html'), 'is-cursor-active');
    }
}

/*
TRIGGER USAGE : 
    - data-cursor-trigger                       = Define trigger element
    - data-cursor="show/hide"                   = show / hide mouse cursor
    - data-cursor-type="default/secondary"      = Use alternate mouse follower (if more than one in same page)

<a data-cursor-trigger data-cursor="show" href="#" aria-label="Text">
    <img>
</a>
<div data-cursor-trigger data-cursor="hide" data-cursor-type="secondary">
    <img>
</div>


CURSORS USAGE :
    - Append to the bottom of the template page (just on top of <?php get_footer(); ?>)

<div class="js-cursor c-cursor__wrap" data-module="MouseCursor">
    <div class="c-cursors">
        <div class="c-cursor" data-cursor-type="default">
            <div class="c-cursor__text">
                <?php _e('Détails', 'stereo'); ?>
            </div>
        </div>
        <div class="c-cursor -secondary" data-cursor-type="secondary">
            <div class="c-cursor__text">
                <?php _e('Plus de détails', 'stereo'); ?>
            </div>
        </div>
    </div>
</div>

*/